// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5WAjQ","icon":"styles_icon__P2Ik8"};